import type {
  GetFeedParams,
  GetFeedResponse,
  FeedPage,
  NewsfeedItem,
  NewsfeedItemResponse,
  NewsfeedTranslation,
  NewsfeedTranslationResponse,
} from './Newsfeed.types';

export const NEWSFEED_COMMENTS_PAGE = 'limit=50&offset=0';

const toNewsfeedTranslation = (translation: NewsfeedTranslationResponse): NewsfeedTranslation => ({
  ...translation,
  answers: translation.answers.map((answer) => ({ ...answer, id: String(answer.id) })),
});

/** Normalises a post from either newsfeed source: ids become strings, optional blocks get defaults. */
export const toNewsfeedItem = ({ accountID, ...item }: NewsfeedItemResponse): NewsfeedItem => ({
  ...item,
  id: String(item.id),
  accountId: item.accountId ?? accountID,
  answers: (item.answers ?? []).map((answer) => ({ ...answer, id: String(answer.id) })),
  metrics: { comments: item.metrics?.comments ?? 0 },
  translation: item.translation ? toNewsfeedTranslation(item.translation) : null,
  canManage: item.canManage ?? false,
  updatedAt: item.updatedAt ?? item.publishedAt,
  confirmation: item.confirmation ?? null,
});

// `countOnly` answers with an empty list: only the pagination block carries information.
export const toFeedPage = (res: GetFeedResponse): FeedPage => ({
  pagination: res.pagination,
  data: (res.data ?? []).map(toNewsfeedItem),
});

export const buildFeedQuery = ({ limit, offset, unreadOnly, countOnly, locale }: GetFeedParams): string => {
  const params = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
    unreadOnly: String(unreadOnly),
  });
  if (countOnly) {
    params.set('countOnly', 'true');
  }
  if (locale) {
    params.set('locale', locale);
  }
  return params.toString();
};

export const withLocale = (path: string, locale: string | null): string =>
  locale ? `${path}?locale=${encodeURIComponent(locale)}` : path;
